import React, { useEffect, useState } from 'react';
import './HeroSection.css';

const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  return (
    <section className={`hero-section ${isVisible ? 'visible' : ''}`}>
      <video 
        className="hero-video"
        autoPlay 
        loop 
        muted 
        playsInline
      >
        <source src="/assets/video1.mp4" type="video/mp4" />
      </video>
      
      <div className="hero-overlay"></div>
      
      <div className="hero-content">
        <img 
          src="/assets/TheaMou.png" 
          alt="TheaMou Logo" 
          className="hero-logo"
        />
        <h1 className="hero-title">Θεά Μου</h1>
        <p className="hero-subtitle">My Goddess</p>
        <div className="hero-divider"></div>
        <p className="hero-text">
          Where myth meets modernity. TheaMou unites MeaDea by Theo, Iellele by Theo, 
          and aligned initiatives under divine creative vision—honoring Greek heritage 
          while igniting the Light of Beginnings into the future of global fashion.
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
